import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e8ebd4b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2e8ebd4b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8ebd4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e8ebd4b')) {
      api.createRecord('2e8ebd4b', component.options)
    } else {
      api.reload('2e8ebd4b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e8ebd4b&scoped=true", function () {
      api.rerender('2e8ebd4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/logistics/company/csgAdmin/rateNew/index.vue"
export default component.exports